import React, { Component } from "react";
import { Form, Popup, Icon, Message, Button, Dropdown } from "semantic-ui-react";
import _ from 'lodash';
import parse from "html-react-parser";

class GameTypes extends Component {
  constructor(props) {
    super(props);

    /*
    set state of SelectedCardSet, CardSetID
    if event has winning card in it
     set State of selectedCard = event.card
    else
     set State of selectedCard = selectedCardSet.defaultCard
    */

    const { event, games } = props;

    // grab the cardsetId for the Event
    const cardSetId = event.card_set_id;

    //TODO if we are getting CTA cardSet here we need some error checking and better way of determining the entry for CTA
    // get the card sets defined for the game type
    const setArray = _.cloneDeep(games[3].cardSets);

    //find the selected cardSetRow from the list of cardsets
    let cardSetrow = _.find(setArray, { id: cardSetId });

    //find the winning card for the event or the default for the card set
    const winCard = _.cloneDeep(event.card  ? event.card : cardSetrow.default_winning_card);

    const ranks = _(cardSetrow.cards)
      .filter(x => x.suit === winCard.suit)
      .map((value, key) => ({
        key: key,
        suit: key,
        rank: value,
        value: value.rank,
        ranktext: value.rankText,
        text: parse(value.rankText),
        color: value.length > 0 ? value[0].color : "#000"
      })).value();

    this.state = {
      groupedCards: [],
      ranks: ranks,
      cardSetId: cardSetId,
      cardSets: setArray,
      selectedCardSetRow: cardSetrow,
      winningCard: winCard,
      selectedSuit: winCard.suit
    }

    this.handleClearDropdown = this.handleClearDropdown.bind(this);
    this.handleRemoveSubscriptionGroup = this.handleRemoveSubscriptionGroup.bind(this);
  }

  componentDidMount = () => {
    const { winningCard } = this.state;
    const { handleChange } = this.props;
    handleChange(null, { name: "event.card", value: winningCard });
  };

  handleRankChange = (e, data) => {
    const { handleChange } = this.props;
    let selectedRank = _.find(data.options, ({ value: data.value }));
    let winningCard = selectedRank.rank;

    this.setState({ winningCard: winningCard });
    handleChange(null, { name: "event.card", value: winningCard });
  }

  handleSuitChange = (e, data) => {
    const { selectedCardSetRow } = this.state;
    const { handleChange } = this.props;
    const ranks = _(selectedCardSetRow.cards)
      .filter(x => x.suit === data.value)
      .map((value, key) => ({
        key: key,
        suit: key,
        rank: value,
        value: value.rank,
        ranktext: value.rankText,
        text: parse(value.rankText),
        color: value.length > 0 ? value[0].color : "#000"
      })).value();
    let selectedSuit = _.find(data.options, ({key: data.value}));

    // Auto-select card rank if suit selected is either RJ or BJ
    let winningCard = null;
    if (selectedSuit.suit === "RJ" || selectedSuit.suit === "BJ") winningCard = ranks[0].rank;

    this.setState({ ranks: ranks, winningCard: winningCard, selectedSuit: selectedSuit.suit });
    handleChange(null, { name: "event.card", value: winningCard });
  }

  handleCardSetChange = (e, data) => {
    const { cardSets, winningCard } = this.state;
    const { handleChange } = this.props;
    const newSelectedCardSetRow = _.find(cardSets, (item) => {
      return item.id === data.value
    });
    const ranks = _(newSelectedCardSetRow.cards)
    .filter(x => x.suit === newSelectedCardSetRow.default_winning_card.suit)
    .map((value, key) => ({
      key: key,
      suit: key,
      rank: value,
      value: value.rank,
      ranktext: value.rankText,
      text: parse(value.rankText),
      color: value.length > 0 ? value[0].color : "#000"
    })).value();

    this.setState({
      winningCard: newSelectedCardSetRow.default_winning_card,
      selectedCardSetRow: newSelectedCardSetRow,
      cardSetId: newSelectedCardSetRow.id,
      ranks: ranks,
      selectedSuit: winningCard && winningCard.suit
    });
    handleChange(null, { name: "event.card_set_id", value: newSelectedCardSetRow.id });
    handleChange(null, { name: "event.card", value: newSelectedCardSetRow.default_winning_card });
  }

  handleClearDropdown () {
    const { handleChange } = this.props;
    handleChange(null, { name: "event.parent_id", value: false });
  }

  handleRemoveSubscriptionGroup () {
    const { handleChange } = this.props;
    handleChange(null, { name: "event.event_subscription_group_id", value: false });
  }

  render() {
    const { games, event, valid, language, config, NonAddOnEventList, handleChange, setRules, handleStep, subscriptionGroups, subscriptionEnabled } = this.props;
    const { ranks, cardSets, cardSetId, selectedCardSetRow, winningCard, selectedSuit } = this.state;
    const rules = {
      game_id: "required|integer|min:1",
      percent_nonprofit: "required|prize_split",
      card_rank: "required",
      draw: "required",
      calendar_jackpot: "required|min:1",
      event_subscription_group_id: "not_same_as_main_event_group"
    };
    const customMessages = {
      "min.game_id": "A game type must be selected",
      "required.draw": "Grand Prize field is required",
      "required.calendar_jackpot": "Amount per draw is required for Calendar raffles",
      "min.calendar_jackpot": "Amount per draw is required for Calendar raffles"
    };

    // strip out merchandise validation rules if any
    if (event.game_id !== 2) delete rules['draw'];

    // strip out cta validation rules if any
    if (event.game_id !== 3) {
      delete rules['card_rank']
    } else if (winningCard !== null) delete rules['card_rank'];

    // strip out calendar validation rules if any
    if (event.game_id !== 4) delete rules['calendar_jackpot'];

    setRules(rules, customMessages);

    let disabledPercent = false;
    if (event.game_id > 0 && +games[event.game_id].settings.can_modify_percent === 0) disabledPercent = true;
    if (!event.is_first_thread) disabledPercent = true;

    let disabledCard = false;
    if (event.game_id > 0 && +games[event.game_id].settings.can_modify_card === 0) disabledCard = true;
    if (!event.is_first_thread) disabledCard = true;

    let disabledPrizeDistribution = false;
    if (event.game_id) disabledPrizeDistribution = true;

    // Helper function to get prize title
    const getPrizeTitle = (languageList, gameId) => {
      const prizeTitle = languageList.find(item => item.varname === `game_${gameId}_prize_title`);
      return prizeTitle ? prizeTitle.value : '';
    };

    // Helper function to get jackpot title
    const getJackpotTitle = (languageList, gameId) => {
      const jackpotTitle = languageList.find(item => item.varname === `game_${gameId}_jackpot_title`);
      return jackpotTitle ? jackpotTitle.value : '';
    };

    return (
      <Form size="big" error={valid.errorCount > 0}>
        <Message
          error
          content={Object.keys(valid.errors.all()).map((item, key) => {
            return (
              <span key={key}>
                {valid.errors.first(item)}
                <br />
              </span>
            );
          })}
        />
        <Form.Group>
          <Form.Field inline disabled={+event.id > 0} required>
            <label>Game Type</label>
          </Form.Field>
          {games.map((v, k) => {
            return (<Form.Radio
              key={`game_type${v.id}`}
              label={v.text}
              value={v.value}
              name="event.game_id"
              checked={event.game_id === v.value}
              onChange={handleChange}
              disabled={+event.id > 0}
            />)
          })}
        </Form.Group>
        {config.addons_enabled && event.game_id !== 3 && !event.is_import_raffle &&
        <Form.Group inline>
            <Form.Select
                name="event.parent_id"
                label="Add event onto"
                options={_(NonAddOnEventList)
                    .map((value, key) => ({
                        key: key,
                        value: parseInt(value.id),
                        text: value.title,
                    })).value()
                }
                value={event.parent_id}
                onChange={handleChange}
                autoComplete="off"
                disabled={+event.addonEventIds.length > 0}
                className="selectParentEventDropdown"
            />
            <Form.Button
              type="button"
              icon={"delete"}
              size="mini"
              color={"red"}
              onClick={this.handleClearDropdown}
              disabled={+event.addonEventIds.length > 0}
              className="refreshParentEventDropdown"
            />
        </Form.Group>}
        {disabledPrizeDistribution &&
          <Form.Group>
            <Form.Field disabled={+event.id > 0}>
              <Popup
                trigger={
                  <label>
                    <Icon name="help circle" color="blue" fitted /> {`% to ${getPrizeTitle(language.en, event.game_id)}`}
                  </label>
                }
                content={`Here you may enter a percentage of the sales that will go to ${getPrizeTitle(language.en, event.game_id)}.`}
                inverted
                wide
              />
              <Form.Input
                type="number"
                name="event.percent_prize"
                value={event.percent_prize}
                onChange={handleChange}
                disabled={disabledPercent}
              />
            </Form.Field>
            {/* Allow seeding for Chase the Ace */}
            {event.game_id === 3 && (
              <Form.Field disabled={+event.id > 0}>
                <Popup
                  trigger={
                    <label>
                      <Icon name="help circle" color="blue" fitted /> {`% to ${getJackpotTitle(language.en, event.game_id)}`}
                    </label>
                  }
                  content={`Here you may enter a percentage of the sales that will go to ${getJackpotTitle(language.en, event.game_id)}.`}
                  inverted
                  wide
                />
                <Form.Input
                  type="number"
                  name="event.percent_seed"
                  value={event.percent_seed}
                  onChange={handleChange}
                  disabled={disabledPercent}
                />
              </Form.Field>
            )}
            <Form.Field disabled>
              <Popup
                trigger={
                  <label>
                    <Icon name="help circle" color="blue" fitted /> % to Non-Profit
              </label>
                }
                content="Here you may enter a percentage of the sales that will go to the non-profit."
                inverted
                wide
              />
              <Form.Input
                type="number"
                name="event.percent_nonprofit"
                value={event.percent_nonprofit}
                onChange={handleChange}
              />
            </Form.Field>
          </Form.Group>}
        {event.game_id === 2 && (
          <Form.Field required>
            <Popup
              trigger={
                <label>
                  <Icon name="help circle" color="blue" fitted /> Grand Prize
              </label>
              }
              content="This will be the grand prize for the draw. You can add more prizes later."
              inverted
              wide
            />
            <Form.Input
              name="event.draw"
              value={event.draw}
              onChange={handleChange}
            />
          </Form.Field>
        )}
        {event.game_id === 3 && (
          <Form.Group >
            <Form.Field required disabled={+event.id > 0}>
              <Popup
                trigger={
                  <label>
                    <Icon name="help circle" color="blue" fitted /> {`Card Set`}
                  </label>
                }
                content={`Select the Card Set to be used for the Raffle`}
                inverted
                wide
              />
              <Form.Select
                name="event.card_set"
                options={_(cardSets).map((cardSet) => (
                  {
                    key: cardSet.id,
                    value: cardSet.id,
                    text: cardSet.name,
                  }
                )).value()
                }
                defaultValue={cardSetId}
                onChange={this.handleCardSetChange}
                disabled={disabledCard}
              />
            </Form.Field>
            <Form.Field required disabled={+event.id > 0}>
              <Popup
                trigger={
                  <label>
                    <Icon name="help circle" color="blue" fitted /> {`Card Suit`}
                  </label>
                }
                content={`Select the Card Suit to be used for the Raffle`}
                inverted
                wide
              />
              <Form.Select
                name="event.card_suit"
                options={_(selectedCardSetRow.cards)
                  .groupBy(x => x.suit)
                  .map((value, key) => ({
                    key: key,
                    suit: key,
                    ranks: value,
                    value: key,
                    suittext: value.length > 0 ? value[0].suitText : "",
                    text: parse(value.length > 0 ? value[0].suitText : ""),
                    color: value.length > 0 ? value[0].color : "#000"
                  })).value()
                }
                value={winningCard ? winningCard.suit : selectedSuit}
                onChange={this.handleSuitChange}
                disabled={disabledCard}
              />
            </Form.Field>
            <Form.Field required disabled={+event.id > 0}>
              <Popup
                trigger={
                  <label>
                    <Icon name="help circle" color="blue" fitted /> {`Card Rank`}
                  </label>
                }
                content={`Select the Card Rank to be used for the Raffle`}
                inverted
                wide
              />
              <Form.Select
                name="event.card_rank"
                options={ranks}
                value={winningCard ? winningCard.rank : null}
                onChange={this.handleRankChange}
                disabled={disabledCard}
              />
            </Form.Field>
          </Form.Group>
        )}

        {event.game_id === 4 && <Form.Input
            name="event.calendar_jackpot"
            label={() => (
            <Popup
                trigger={
                <label>
                    <Icon name="help circle" color="blue" fitted /> Amount per draw
                </label>
                }
                content="Use this option to set an amount per draw for Calendar raffles."
                inverted
                wide
            />
            )}
            value={event.calendar_jackpot}
            onChange={handleChange}
            disabled={event.id > 0}
            required
        />}
      {subscriptionEnabled &&
        <Form.Field>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Form.Select
                label="Subscription Group"
                name="event.event_subscription_group_id"
                value={event.event_subscription_group_id}
                style={{ width: '760px' }} // reduced the width to account for button
                disabled={event.id > 0}
                options={subscriptionGroups.map(group => ({ key: group.id, text: group.text, value: group.id }))}
                onChange={handleChange}
              />
              <Form.Button
                  type="button"
                  icon={"delete"}
                  size="mini"
                  color={"red"}
                  disabled={event.id > 0}
                  onClick={this.handleRemoveSubscriptionGroup}
              />
          </div>
        </Form.Field>
      }
        <Button
          type="button"
          primary
          size="large"
          content="Save And Continue"
          onClick={() => handleStep("non-profit")}
          disabled={event.game_id === 3 && (!winningCard || !winningCard.rank || !winningCard.suit)}
          floated="right"
        />
        <Button
          type="button"
          size="large"
          content="Go Back"
          onClick={() => handleStep("general")}
          floated="right"
        />

      </Form>
    );
  }
}

export default GameTypes;
